import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { ReportProblemModel } from 'src/app/models/report-problem-model';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { ReportProblemViewComponent } from './report-problem-view/report-problem-view.component';
import { NoRecordFound } from 'src/app/constants/common-constant';

@Component({
  selector: 'app-report-problem',
  templateUrl: './report-problem.component.html',
  styleUrls: ['./report-problem.component.scss']
})
export class ReportProblemComponent {
  ReportProblemList: any = [];
  showData: boolean = false;
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  NoRecordFound: any = [];
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'StudentName', 'CreatedDate', 'ReportProblemContent', 'Action'];
  dataSource: MatTableDataSource<ReportProblemModel> = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private router: Router,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.getReportProblemList();
    this.NoRecordFound = NoRecordFound;
    this.sharedService.setData('Report Problem');
  }

  getReportProblemList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.reportProblem.GetReportProblemList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.ReportProblemList = response.data;
          this.dataSource.data = this.ReportProblemList;
          if (this.ReportProblemList.length > 0) {
            TotalRecords = this.ReportProblemList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getReportProblemList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getReportProblemList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getReportProblemList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getReportProblemList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getReportProblemList();
    this.searchClose = false;
  }

  onView(reportProblemId: number) {
    var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', reportProblemId);
    this.router.navigate(['report-problem/view', encrypted]);
  }

  ReportListDetail(reportProblemId: number) {
    const modalRef = this.modalService.open(ReportProblemViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.reportProblemId = reportProblemId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  Deletepopup() {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }
}
